import React from "react";

function TemplateChoiceButton({
  title,
  onClick,
  selected,
  dataTestId,
}) {
  return (
    <button
      className={`h-auto text-white flex flex-col items-center justify-center p-6 w-56 border-2 rounded-xl cursor-pointer space-y-3 transition-colors text-lg md:text-xl font-medium shadow-md
          ${
            selected
              ? "bg-brand/80 border-brand backdrop-blur-xs"
              : "bg-white/10 border-white/20 backdrop-blur-xs hover:bg-brand/30 hover:scale-105 transition-transform duration-200"
          }`}
      onClick={onClick}
      type="button"
      data-testid={dataTestId}
    >
      {title}
    </button>
  );
}

export default function TemplateChoiceStep({
  selected,
  setSelected,
}) {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <h3 className="text-center mb-8 text-3xl font-semibold text-white">
        Do you have your own template?
      </h3>
      <div className="flex flex-wrap gap-6 md:flex-row justify-center text-center h-full sm:h-auto">
        <TemplateChoiceButton
          title="I have my own SOAP template"
          onClick={() => setSelected("soap")}
          selected={selected === "soap"}
          dataTestId="use-own-soap-template-button"
        />
        <TemplateChoiceButton
          title="I have my own non-SOAP template"
          onClick={() => setSelected("non-soap")}
          selected={selected === "non-soap"}
          dataTestId="use-own-non-soap-template-button"
        />
        <TemplateChoiceButton
          title="I'll try Scribenote's templates."
          onClick={() => setSelected("scribenote")}
          selected={selected === "scribenote"}
          dataTestId="use-scribenote-templates-button"
        />
      </div>
      <h5 className="text-center text-white text-base md:text-lg font-medium mt-6">
        Don&apos;t worry, you can always add a template later.
      </h5>
    </div>
  );
}
